import { BillingRepository } from "../../../repositories/billingRepository"
import { UseCase } from "../../useCase"
import { UpdateInvoiceRequest } from "./request"
import { UpdateInvoiceResponse } from "./response"

export class UpdateInvoiceUseCase implements UseCase<UpdateInvoiceRequest, UpdateInvoiceResponse> {
	private _repository
	constructor({ BillingRepository }: { BillingRepository: BillingRepository }) {
		this._repository = BillingRepository
	}
	exec({ invoiceId, ...data }: UpdateInvoiceRequest): Promise<UpdateInvoiceResponse> {
		return this._repository.updateInvoice(invoiceId, data)
	}
}
